import React, { useState } from 'react';

function PastPerformanceBar() {
  const [hitCall, setHitCall] = useState(1017);
  const [missCall, setMissCall] = useState(58);
  const [accuracy, setAccuracy] = useState(75);
  const [selectedperformance, setSelectedperformance] = useState('Stocks');
  return (
    <div className='bg-white rounded p-2'>
      <div className='d-lg-flex justify-content-center'>
        <div
          aria-hidden
          style={{
            backgroundColor:
              selectedperformance === 'Stocks' ? '#041758' : '#007dfe',
          }}
          className='rounded-4 mx-lg-2 my-2 shadow-sm p-1 px-5 rounded'
          onClick={() => {
            setHitCall(1017);
            setMissCall(58);
            setAccuracy(75);
            setSelectedperformance('Stocks');
          }}
        >
          <p className='text-white fw-semibold'>Stocks</p>
        </div>
        <div
          aria-hidden
          style={{
            backgroundColor:
              selectedperformance === 'Futures' ? '#041758' : '#007dfe',
          }}
          className='rounded-4 mx-lg-2 my-2 shadow-sm p-1 px-5 rounded'
          onClick={() => {
            setHitCall(417);
            setMissCall(162);
            setAccuracy(78);
            setSelectedperformance('Futures');
          }}
        >
          <p className='text-white fw-semibold'>Futures</p>
        </div>
        <div
          aria-hidden
          style={{
            backgroundColor:
              selectedperformance === 'Options' ? '#041758' : '#007dfe',
          }}
          className='rounded-4 mx-lg-2 my-2 shadow-sm p-1 px-5 rounded'
          onClick={() => {
            setHitCall(51);
            setMissCall(4);
            setAccuracy(80);
            setSelectedperformance('Options');
          }}
        >
          <p className='text-white fw-semibold'>Options</p>
        </div>
      </div>
      <div className='border border-1 p-2 rounded bg-white mt-1'>
        <h4>{accuracy}% Accuracy</h4>

        <div style={{ width: '100%' }}>
          <div style={{ width: '100%', height: '100%' }}>
            <div style={{ display: 'flex', height: '100%' }}>
              <div
                className='rounded-start'
                style={{
                  height: '20px',
                  width: `${accuracy}%`,
                  backgroundColor: 'green',
                }}
              />
              <div
                className='rounded-end'
                style={{
                  height: '20px',
                  width: `${100 - accuracy}%`,
                  backgroundColor: 'red',
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>Hit: {hitCall}</div>
            <div>Miss: {missCall}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PastPerformanceBar;
